/*
 * @author Sergey Kuzhavskiy <Praffesor>
 */
const dependencies = ['$scope', 'uploadService', 'Booking'];

const PopupBookingUploadController = function($scope, uploadService, Booking) {

  const vm = this;

  vm.uploadFile = function () {
    uploadService.uploadFile(Booking.importBookingsUrl(), vm.importFile.fileUploaded, function (importResult) {
      $scope.uploadSuccessCb({ importResult });
    });
  };

  vm.getDownloadTemplateUrl = function() {
    return Booking.importTemplateUrl();
  };

  $scope.$on('popup.open', function() {
    if ($scope.popupShowCondition) {
      initFile();
    }
  });

  const initFile = function () {
    vm.importFile = {
      file: undefined,
      fileName: undefined,
      fileUploaded: undefined
    };
  };

  return vm;
};

angular.module('popup.booking')
  .controller('PopupBookingUploadController', dependencies.concat(PopupBookingUploadController));
